<template>
  <div class="position-relative">
    <UiInput
        :type="showPassword ? 'text':'password'"
        v-model="currentValue"
        @input="onInput"
    />

    <i class="position-absolute top-0 right-0 fa "
       :class="showPassword ? 'fa-eye-slash':'fa-eye'"
       @click="showPassword = !showPassword"></i>
  </div>
</template>

<script>

import UiInput from "./forms/UiInput.vue";

export default {
  components: {UiInput},
  props: ["value"],
  data() {
    return {
      showPassword: false,
      currentValue: this.value
    };
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
  }
}
</script>


<style scoped lang="scss">
i {
  cursor: pointer;
  font-size: 2rem;
  line-height: 38px;
  text-align: center;
  width: 38px;
}
</style>